/**
 * 5 Free Parties giveaway (owner request 2026-09-12). Shared by the
 * /free-parties page and the homepage banner so both close at the same
 * moment. Submissions close end of day Oct 12, 2026 Pacific (still PDT,
 * UTC-7), so the cutoff is midnight PT = 07:00 UTC on Oct 13.
 */

export const FREE_PARTIES_FORM_URL =
  'https://docs.google.com/forms/d/1OCeIh9nq__76fRvBbQXlqI1YeP6S65rO15cD8Q6CPNY/viewform';

export const FREE_PARTIES_DEADLINE = new Date('2026-10-13T07:00:00Z');

export const isFreePartiesOpen = (now = new Date()) => now < FREE_PARTIES_DEADLINE;
